import { clsx } from 'clsx'
import { type FC } from 'react'
import { useIntl } from 'react-intl'

import { priceGetFormattedPrice } from '../../../../price'

import { ProductListPriceLabel } from './ProductListPriceLabel'

type ProductListPriceProps = {
  className: string
  isOfferMirakl: boolean
  isPrescriptionProduct: boolean
  isThirtyDayPriceTrendDown: boolean
  priceToShow: number
  shouldVisuallyStrikeThroughPrice: boolean
  showThirtyDaysPrice: boolean
}

export const ProductListPrice: FC<ProductListPriceProps> = ({
  className,
  isOfferMirakl,
  isPrescriptionProduct,
  isThirtyDayPriceTrendDown,
  priceToShow,
  shouldVisuallyStrikeThroughPrice,
  showThirtyDaysPrice,
}) => {
  const intl = useIntl()

  return (
    <div className={clsx('flex gap-x-1', className)}>
      <ProductListPriceLabel
        isOfferMirakl={isOfferMirakl}
        isPrescriptionProduct={isPrescriptionProduct}
        isThirtyDayPriceTrendDown={isThirtyDayPriceTrendDown}
        showThirtyDaysPrice={showThirtyDaysPrice}
      />
      <span
        className={clsx(shouldVisuallyStrikeThroughPrice && 'line-through')}
        data-qa-id="product-old-price"
      >
        {priceGetFormattedPrice(priceToShow, intl)}
      </span>
    </div>
  )
}
